import { useRouteParams } from "src/hooks/useRouteParams";
import { useDevelopmentScopeTemplatePageQuery } from "src/routes/developments/templates/DevelopmentScopeTemplatePage.generated";
import { ScopeTemplateHeader } from "src/routes/developments/templates/components/ScopeTemplateHeader";
import { ItemTemplateItemParams } from "src/routes/routesDef";
import { ItemTemplateLineItemsTab } from "src/routes/settings/itemTemplates/ItemTemplateLineItemsTab";
import { ItemTemplateAnomaliesProvider } from "src/routes/settings/itemTemplates/anomalies/ItemTemplateAnomaliesContext";
import { queryResult } from "src/utils";

export function DevelopmentScopeTemplatePage() {
  const { itemTemplateId } = useRouteParams<ItemTemplateItemParams>();
  const query = useDevelopmentScopeTemplatePageQuery({ variables: { itemTemplateId } });
  return (
    <ItemTemplateAnomaliesProvider templateId={itemTemplateId}>
      {queryResult(query, ({ itemTemplate }) => (
        <>
          <ScopeTemplateHeader itemTemplate={itemTemplate} />
          <ItemTemplateLineItemsTab
            mode={"development"}
            itemTemplateId={itemTemplate.id}
            isVersioned={itemTemplate.isVersioned}
            templateStatus={itemTemplate.statusDetail}
          />
        </>
      ))}
    </ItemTemplateAnomaliesProvider>
  );
}
